<template>
  <div id="app">
   <div class="bodycont">
   	 <div class="head">
   		 <div class="headrcont Pub_flexrow Pub_width">
   		<img :src="$Pub_url+pagesite.logo" class="headlogo"/>
   		<div class="headmesg ">
   			<div class="mesgcard" style="white-space: nowrap;" >{{pagesite.keywords}}</div>
			<div class="serachbox Pub_flexrow">
				<input type="searchinput" class="inputcont" placeholder="请输入搜索内容" v-model="searchinput"/>
				<div class="searchbtn" @click="search()">搜索</div>
			</div>
   		</div>
   		<img :src="$Pub_url+wxcode"  class="qrcode"/>
   		</div>
   	 </div>
   	 <!-- 导航 -->
   	 <div class="nav">
          <div class="navlist Pub_flexrowcenter">
   		   <div class="navcard" :class="navindex==index?'navcard_active':''" v-for="(item,index) in menulist" @click="navto(item.scode,index)">{{item.name}}</div>
   	   </div>
   	 </div>
	 <keep-alive>
		  <router-view style="width: 100%;margin: 0 auto;" v-if="$route.path=='/index_page'"/>
	 </keep-alive>
	  <router-view style="width: 100%;margin: 0 auto;" v-if="$route.path!='/index_page'"/>
	 <!-- 底部 -->
	 <div class="footer_nav">
		 <div class="fnav_c">
		 <div class="fnavc_one">
		 <span style="font-size: 18px;font-weight: bold;">友情链接</span>
		 </div>
		 <div class="fnavc_two">
			 <div class="p_vc" v-for="(item,index) in fr_link">
			 <div class="vc_top"><a :href="item.link" style="color: white;text-decoration: none;" target="_blank">{{item.name}}</a></div>
			 </div>
			 
		 </div>
		 </div>
	 </div>
	 <!-- 最底部 -->
	 <div class="footer_content">
			 <div class="f_imgdiv">
		<!-- 	 <img src="template/default/images/home/wxtb.png" style="margin-right: 85px;">
			 <img src="template/default/images/home/xlwb.png"> -->
			 </div>
			 <div>
			 <span>地址：{{companymesg.address}}</span>
			 </div>
			 <div>
			 <span class="f_phone">{{companymesg.mobile}}</span>
			 <span class="f_email">E-mail：{{companymesg.email}}</span>
			 </div>
			 <div>
			 <a href="https://beian.miit.gov.cn" target="_blank">{{pagesite.icp}}</a></span>
			 </div>
	 </div>
   </div>
  </div>

</template>


<script>
	export default ({
	  name: 'App',
	  data(){
		return{
		  headmesg:[],	
		  menulist:[],
		  fr_link:[],
		  navindex:0,
		  pagesite:[],
		  wxcode:"",
		  companymesg:[],
		  searchinput:""
		}
	  },
	  methods:{
		loadlist(){
			// 顶部导航
			 this.$Get("api.php/cms/nav").then(res=>{
				 res.data.data.unshift({name:"首页"})
				 // res.data.data.push({name:"联系我们"})
				this.menulist=res.data.data
			 })
			 this.$Get("api.php/cms/link/gid/1").then(res=>{
			 	 this.fr_link=res.data.data
			 })
			 // logo
			 this.$Get("api.php/cms/site").then(res=>{
			 	this.pagesite=res.data.data
			 })
			 // 微信二维码
			 this.$Get("api.php/cms/company").then(res=>{
			 	this.wxcode=res.data.data.weixin
				this.companymesg=res.data.data
			 })
		},
		search(){
			if(this.searchinput==""){
				return
			}
			this.$router.push({name:"search",query:{keyword:this.searchinput}})
		},
		// 顶部导航跳转
		navto(scode,index){
			this.navindex=index
			if(index==0){
				this.$router.push({"path":"/"})
				return;
			}
			
			this.$router.push({"name":"FL_page",query:{scode:scode}})
		}
	  },
	  created(){
		this.loadlist();
	  },
	  mounted(){

	  },
	  activated(){

	  }
})
</script>

<style scoped="scoped">
.flexrow{
		display: flex;
		flex-direction: row;
	}
	.flexcoloum{
		display: flex;
		flex-direction: column;
	}
	.bodycont{
		min-width: 1200px;
		margin: 0 auto;
		background: #edeff0;
	}
	.head{
		width: 1200px;
		margin: 0 auto;
	}
	.headrcont{
		width: 1200px;
	}
	.headlogo{
		width: 521px;
		height: 100%;
		position: relative;
		left: 25px;
		top: 5px;
	}
	.headmesg{
		margin-left: 55px;
		padding-top: 9px;
	}
	.mesgcard{
		color: #336ea6;
		font-size: 34px;
		font-weight: bold;
		font-family:cursive;
	}
	.serachbox{
		margin-top: 10px;
	}
	.inputcont{
		width: 220px;
		height: 30px;
		border: none;
		box-shadow: 0px 0px 0px 0px #eee;
		outline: none;
		padding-left: 10px;
	}
	.searchbtn{
		background: #336ea6;
		text-align: center;
		height: 30px;
		line-height: 30px;
		width: 100px;
		font-size: 15px;
		color: white;
		cursor: pointer;
	}
	.qrcode{
		width: 101px;
		margin-left: 155px;
	}
	
	/* 导航 */
	.nav{
		background-color: #005b9f;
		color: white;
		min-width: 1200px;
		margin: 0 auto;
		height: 50px;
	}
	.navlist{
		width: 1200px;
		margin: 0 auto;
		align-items: center;
		height: 50px;
		justify-content: space-between;
	}
	.navcard{
		color: white;
		font-size: 17px;
		text-align: center;
		height: 50px;
		width: 100%;
		line-height: 50px;
		cursor: pointer;
	}
	.navcard_active{
		text-decoration: underline;
		background: #024287;
	}
	.navcard:hover{
		text-decoration: underline;
		background: #024287;
		
	}
	
	
	
	
	.footer_nav{
		width: 100%;
		background: #448ACA;
		min-height: 100px;
		margin-top: 20px;
	}
	.fnav_c{
		display: flex;
		align-items: center;
		width: 1200px;
		margin: 0 auto;
		color: white;
	}
	.fnavc_two{
		width: 85%;
		display: inline-block;
		vertical-align: top;
		min-height: 100px;
		line-height: 30px;
		margin: 0 auto;
	}
	.fnavc_one{
		width: 10%;
		text-align: center;
		min-height: 100px;
		line-height: 100px;
		display: inline-block;
		vertical-align: top;
	}
	.fnavc_two {
	    width: 85%;
	    font-size: 14px;
	    display: inline-block;
	    vertical-align: top;
	    min-height: 100px;
	    line-height: 30px;
	}
	.fnavc_two .p_vc {
	    font-size: 14px;
	    padding-left: 10px;
	    padding-right: 10px;
	    display: inline-block;
	    vertical-align: top;
	}
	
	
	.footer_content {
	    width: 85%;
	    text-align: center;
	    line-height: 30px;
	    padding-bottom: 10px;
	    font-size: 14px;
	    font-family: 微软雅黑;
	    margin: 10px auto 0px;
	}
	
</style>



// WEBPACK FOOTER //
// src/App.vue